<template>
  <div class="topBack" style="margin-top: 8px;">
    <img :src="back" alt="" @click="goBack">
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
import back from '@/assets/images/common/back.svg'
export default {
  name: 'TopBack',
  props: ['title', 'handelBack'],
  data () {
    return {
      back
    }
  },
  methods: {
    goBack () {
      if (this.handelBack) {
        this.handelBack()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .topBack {
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin-top: 10px;
    img {
      width: 30px;
    }
    .title {
      font-size: 18px;
      line-height: 30px;
      color: #F6D9AA;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PredictTopBack/index.vue